import React, { useState, useEffect, useRef } from 'react';
import { Edit2, Check, X, Plus, Trash2, Star, ChevronUp, ChevronDown } from 'lucide-react';
import { updateAccount } from '../services/firestoreService';
// 6 department sections: emoji for header, default items as { emoji, label }
export const DEPARTMENT_SECTIONS = [
  {
    id: 'sales',
    name: 'Sales',
    color: 'red',
    emoji: '📈',
    items: [
      { emoji: '👥', label: 'Structure & Model' },
      { emoji: '💬', label: 'Referral Partners' },
      { emoji: '✅', label: 'Process & Closing' },
      { emoji: '📝', label: 'Proposals and Contracts' },
    ],
  },
  {
    id: 'operations',
    name: 'Operations',
    color: 'blue',
    emoji: '⚙️',
    items: [
      { emoji: '🚀', label: 'Scaling Roadmap' },
      { emoji: '⚙️', label: 'SOP Implementation' },
      { emoji: '📋', label: 'Roles & Job Descriptions' },
      { emoji: '🎯', label: 'KPI Setting & Tracking' },
    ],
  },
  {
    id: 'technology',
    name: 'Technology',
    color: 'purple',
    emoji: '💻',
    items: [
      { emoji: '🗂️', label: 'CRM' },
      { emoji: '🌐', label: 'Tech Stack' },
      { emoji: '⚡', label: 'Automation' },
      { emoji: '🤖', label: 'AI Usage' },
    ],
  },
  {
    id: 'finance',
    name: 'Finance',
    color: 'green',
    emoji: '💰',
    items: [
      { emoji: '💵', label: 'Job Costing' },
      { emoji: '💡', label: 'Financial Clarity' },
      { emoji: '🧠', label: 'Budget' },
      { emoji: '🔍', label: 'Forecasting' },
    ],
  },
  {
    id: 'marketing',
    name: 'Marketing',
    color: 'orange',
    emoji: '📣',
    items: [
      { emoji: '🔔', label: 'Generating Leads' },
      { emoji: '🎨', label: 'Branding' },
      { emoji: '💻', label: 'Digital Presence' },
      { emoji: '📊', label: 'Marketing ROI' },
    ],
  },
  {
    id: 'hr',
    name: 'HR',
    color: 'yellow',
    emoji: '👥',
    items: [
      { emoji: '👤', label: 'Hiring' },
      { emoji: '📖', label: 'Compliance' },
      { emoji: '📚', label: 'Employee Materials' },
      { emoji: '🚀', label: 'Company Direction' },
    ],
  },
];

const POPULAR_EMOJIS = [
  '🚀', '⚡', '🔥', '💡', '🎯', '📈', '🔄', '⚙️', '🎨', '📱',
  '💻', '🌐', '📊', '🎪', '🏆', '💎', '🌟', '🎭', '📝', '📋',
  '📅', '⏰', '🔔', '📧', '💬', '📞', '📹', '🎵', '🛒', '💰',
  '💳', '📦', '🚚', '🏢', '👥', '👤', '🎓', '🔐', '🔍', '📌',
  '📍', '🤖', '🧠', '🔧', '🔨', '🛠️', '✅', '❌', '⚠️', 'ℹ️',
  '📚', '📖', '✏️', '📐', '🧮', '🔬', '🧪', '🔭', '📡', '🛰️',
  '🎡', '🎢', '🎠', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷',
  '🎺', '🎸', '🎻', '🎲', '🎯', '🎳', '🎮', '🎰', '🧩', '📷',
  '📸', '📹', '📺', '📻', '📟', '📠', '☎️', '💡', '🔦', '🕯️',
  '🪔', '🧯', '💸', '💵', '🪙', '⚖️', '🪜', '🦯', '🦽', '🦼',
  '📑', '📄', '📃', '📜', '📰', '🗞️', '📓', '📔', '📒', '📕',
  '📗', '📘', '📙', '📚', '📖', '🔖', '🏷️', '💰', '💴', '💵',
  '💶', '💷', '💸', '💳', '🧾', '💹', '📊', '📈', '📉', '📇',
  '📋', '📁', '📂', '🗂️', '🗄️', '🗃️', '📅', '📆', '🗓️', '📆',
  '💌', '📧', '📨', '📩', '📤', '📥', '📦', '📫', '📪', '📬',
  '📭', '📮', '🗳️', '✉️', '💬', '💭', '🗯️', '🗨️', '👁️', '🗣️',
  '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️',
  '🗜️', '💾', '💿', '📀', '📼', '🎙️', '🎚️', '🎛️', '⏱️', '⏲️',
  '🔋', '🔌', '🛢️', '🔧', '🔨', '⚒️', '🛠️', '⛏️', '🔩', '🧰',
  '🧲', '🔫', '💣', '🧨', '🔪', '🗡️', '⚔️', '🛡️', '🔮', '📿',
  '🍎', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍈', '🍒', '🍑',
  '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑', '🥦', '🥬', '🥒',
  '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱',
  '✈️', '🛫', '🛬', '🛩️', '💺', '🚁', '🛸', '🚀', '🛰️', '🚂',
  '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞',
  '🚟', '🚠', '🚡', '🚋', '🚌', '🚍', '🚎', '🚐', '🚑', '🚒',
  '🚓', '🚔', '🚕', '🚖', '🚗', '🚘', '🚙', '🚚', '🚛', '🚜',
  '🏎️', '🏍️', '🛵', '🦽', '🦼', '🛴', '🚲', '🛺', '🛹', '🛼',
  '🗽', '🗼', '🏰', '🏯', '🏟️', '🎡', '🎢', '🎠', '⛲', '⛱️',
  '🏖️', '🏝️', '🏜️', '🌋', '⛰️', '🏔️', '🗻', '🏕️', '⛺', '🏠',
  '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥',
  '🏦', '🏨', '🏪', '🏫', '🏩', '💒', '🏛️', '⛪', '🕌', '🕍',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
  '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️',
  '✝️', '☪️', '🕉️', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐',
  '⛎', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐',
  '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳',
  '🆘', '❌', '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨️',
  '♻️', '✅', '🈯', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️',
  '🌀', '💤', '🏧', '🚾', '♿', '🅿️', '🈳', '🈂️', '🛂', '🛃',
  '🛄', '🛅', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁',
  'ℹ️', '🔤', '🔡', '🔠', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓',
  '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣',
  '🔟', '🔢', '#️⃣', '*️⃣', '▶️', '⏸️', '⏯️', '⏹️', '⏺️', '⏭️',
  '⏮️', '⏩', '⏪', '⏫', '⏬', '◀️', '🔼', '🔽', '➡️', '⬅️',
  '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️', '↪️', '↩️',
  '🔀', '🔁', '🔂', '🔄', '🔃', '🎵', '🎶', '➕', '➖', '➗',
  '✖️', '💲', '💱', '™️', '©️', '®️', '〰️', '➰', '➿', '🔚',
  '🔙', '🔛', '🔜', '🔝', '✔️', '☑️', '🔘', '⚪', '⚫', '🔴',
  '🔵', '🟠', '🟡', '🟢', '🟣', '🟤', '🔶', '🔷', '🔸', '🔹',
  '🔺', '🔻', '💠', '🔳', '🔲', '▪️', '▫️', '◾', '◽', '◼️',
  '◻️', '🟥', '🟧', '🟨', '🟩', '🟦', '🟪', '🟫', '⬛', '⬜',
  '🔈', '🔇', '🔉', '🔊', '🔔', '🔕', '📣', '📢', '♠️', '♣️',
  '♥️', '♦️', '🃏', '🎴', '🀄', '🕐', '🕑', '🕒', '🕓', '🕔',
  '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕜', '🕝', '🕞',
  '🕟', '🕠', '🕡', '🕢', '🕣', '🕤', '🕥', '🕦', '🕧', '☀️',
  '🌞', '⭐', '🌟', '💫', '✨', '⚡', '☄️', '💥', '🔥', '🌈',
  '☔', '❄️', '☃️', '⛄', '🌊', '💧', '💦',
];

export default function KickoffAssessmentSections({ accountId, account, darkMode, readOnly = false, hideSummaryTitle = false }) {
  // `note` is written by the portal kickoff page (PortalKickoffPriorities);
  // carry it through here so a CRM-side save doesn't strip the client's notes.
  const normalizeDeptItem = (item, defaultEmoji = '') => {
    if (typeof item === 'string') return { emoji: defaultEmoji, label: item, highlighted: false, priority: 0, note: '' };
    return {
      emoji: item.emoji || '',
      label: item.label ?? '',
      highlighted: Boolean(item.highlighted),
      priority: typeof item.priority === 'number' ? item.priority : 0,
      note: item.note || '',
    };
  };
  const [deptItems, setDeptItems] = useState(() => {
    const initial = {};
    DEPARTMENT_SECTIONS.forEach((s) => {
      initial[s.id] = (s.items || []).map((it) => normalizeDeptItem(it, s.emoji));
    });
    return initial;
  });
  const [editingCard, setEditingCard] = useState(null); // { deptId, index } inline card editing
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(null); // { deptId, itemIndex }
  const [emojiSearch, setEmojiSearch] = useState('');
  const [priorityOrder, setPriorityOrder] = useState([]); // ordered keys for the Top Priorities summary
  const topPrioritiesRef = useRef(null);
  // Which account id we've already seeded local state from. Parents (CRM kickoff,
  // portal kickoff) load `account` once and never refetch it after a save, so
  // re-running the seed would replay stale data over edits the user just made —
  // that's how added priorities used to vanish and take the rest with them.
  const seededForRef = useRef(null);
  useEffect(() => {
    if (!account) return;
    if (seededForRef.current === (account.id ?? accountId)) return;
    seededForRef.current = account.id ?? accountId;
    const storedItems = account.departmentAssessmentItems || {};
    const items = {};
    DEPARTMENT_SECTIONS.forEach((s) => {
      if (Array.isArray(storedItems[s.id]) && storedItems[s.id].length > 0) {
        items[s.id] = storedItems[s.id].map((it) => normalizeDeptItem(it, s.emoji));
      } else {
        items[s.id] = (s.items || []).map((it) => normalizeDeptItem(it, s.emoji));
      }
    });
    setDeptItems(items);
    setPriorityOrder(Array.isArray(account.departmentPriorityOrder) ? [...account.departmentPriorityOrder] : []);
  }, [account, accountId]);

  const persistItems = (itemsState) => {
    if (!accountId) return;
    updateAccount(accountId, {
      departmentAssessmentItems: normalizeItemsForSave(itemsState),
      lastUpdated: new Date().toISOString(),
    }).catch((e) => console.error('Error saving priorities:', e));
  };

  // Apply a new items map locally AND write it. Both halves must happen together:
  // persisting from inside a setState updater double-fires under StrictMode and
  // makes the saved value depend on render timing.
  const applyItems = (next) => {
    setDeptItems(next);
    persistItems(next);
  };

  const addDeptItem = (deptId) => {
    if (readOnly) return;
    const list = [...(deptItems[deptId] || []), { emoji: '🌟', label: '', highlighted: false, priority: 0 }];
    setDeptItems((p) => ({ ...p, [deptId]: list }));
    setEditingCard({ deptId, index: list.length - 1 });
  };

  const removeDeptItem = (deptId, index) => {
    if (readOnly) return;
    applyItems({ ...deptItems, [deptId]: (deptItems[deptId] || []).filter((_, i) => i !== index) });
    setEditingCard(null);
    setEmojiPickerOpen(null);
  };

  // Finish inline card editing: empty titles are dropped, everything else saves.
  const finishEditCard = () => {
    if (!editingCard) return;
    const { deptId, index } = editingCard;
    const list = [...(deptItems[deptId] || [])];
    const item = list[index];
    const label = typeof item === 'string' ? item : item?.label || '';
    applyItems(
      String(label).trim()
        ? deptItems
        : { ...deptItems, [deptId]: list.filter((_, i) => i !== index) }
    );
    setEditingCard(null);
    setEmojiPickerOpen(null);
  };
  const updateDeptItem = (deptId, index, field, value) =>
    setDeptItems((p) => {
      const list = [...(p[deptId] || [])];
      const item = list[index];
      if (item === undefined) return p;
      if (typeof item === 'string') {
        if (field === 'emoji') {
          list[index] = { emoji: value, label: item, highlighted: false, priority: 0 };
        } else if (field === 'label') {
          list[index] = { emoji: '', label: value, highlighted: false, priority: 0 };
        } else if (field === 'highlighted') {
          list[index] = { emoji: '', label: item, highlighted: Boolean(value), priority: 0 };
        } else if (field === 'priority') {
          list[index] = { emoji: '', label: item, highlighted: false, priority: typeof value === 'number' ? value : 0 };
        }
      } else {
        list[index] = { ...item, [field]: field === 'priority' ? (typeof value === 'number' ? value : 0) : value };
      }
      return { ...p, [deptId]: list };
    });

  const normalizeItemsForSave = (itemsState) => {
    const items = {};
    Object.keys(itemsState).forEach((k) => {
      items[k] = (itemsState[k] || []).map((it) =>
        typeof it === 'string'
          ? { emoji: '', label: it, highlighted: false, priority: 0, note: '' }
          : {
              emoji: it.emoji || '',
              label: it.label || '',
              highlighted: Boolean(it.highlighted),
              priority: typeof it.priority === 'number' ? it.priority : 0,
              note: it.note || '',
            }
      );
    });
    return items;
  };

  // View-mode star/priority clicks save immediately — no separate Save step needed.
  const updateAndPersistItem = (deptId, index, field, value) => {
    if (readOnly) return;
    const list = [...(deptItems[deptId] || [])];
    const item = list[index];
    if (item === undefined) return;
    const base = typeof item === 'string' ? { emoji: '', label: item, highlighted: false, priority: 0 } : { ...item };
    base[field] = field === 'priority' ? (typeof value === 'number' ? value : 0) : value;
    list[index] = base;
    applyItems({ ...deptItems, [deptId]: list });
  };

  // Top Priorities summary: ONLY fully-rated cards (all three dots filled, i.e.
  // gold/starred). Partially-dotted cards stay on their department card below —
  // this list is the short "what actually matters" view.
  const priorityKey = (deptId, label) => `${deptId}|${label}`;
  const topPriorities = (() => {
    const rows = [];
    DEPARTMENT_SECTIONS.forEach((sec) => {
      (deptItems[sec.id] || []).forEach((raw) => {
        const item = typeof raw === 'string' ? { emoji: '', label: raw, highlighted: false, priority: 0 } : raw;
        const label = (item.label || '').trim();
        if (!label) return;
        if (!item.highlighted && (item.priority || 0) < 2) return;
        rows.push({
          key: priorityKey(sec.id, label),
          deptId: sec.id,
          deptName: sec.name,
          emoji: item.emoji,
          label,
        });
      });
    });
    rows.sort((a, b) => {
      const ia = priorityOrder.indexOf(a.key);
      const ib = priorityOrder.indexOf(b.key);
      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;
      return 0;
    });
    return rows;
  })();

  // Five rows per column, filled column-first: 10 priorities become two columns
  // of five rather than one long list.
  const ROWS_PER_COLUMN = 5;
  const priorityColumns = [];
  for (let i = 0; i < topPriorities.length; i += ROWS_PER_COLUMN) {
    priorityColumns.push(topPriorities.slice(i, i + ROWS_PER_COLUMN));
  }

  const moveTopPriority = (index, dir) => {
    if (readOnly) return;
    const keys = topPriorities.map((r) => r.key);
    const target = index + dir;
    if (target < 0 || target >= keys.length) return;
    [keys[index], keys[target]] = [keys[target], keys[index]];
    setPriorityOrder(keys);
    if (accountId) {
      updateAccount(accountId, { departmentPriorityOrder: keys }).catch((e) =>
        console.error('Error saving priority order:', e)
      );
    }
  };

  const DEPT_PILL_COLORS = {
    sales: 'bg-red-500 text-white',
    operations: 'bg-blue-500 text-white',
    technology: 'bg-purple-500 text-white',
    finance: 'bg-green-500 text-white',
    marketing: 'bg-orange-500 text-white',
    hr: 'bg-yellow-500 text-white',
  };

  const textMain = darkMode ? 'text-gray-100' : 'text-gray-900';
  const textMuted = darkMode ? 'text-gray-400' : 'text-gray-500';

  return (
    <div className="space-y-8">
      {/* Top Priorities: cross-department summary of gold/dotted cards, reorderable */}
      <div ref={topPrioritiesRef} className="space-y-3 scroll-mt-24">
        <div className="text-center">
          {!hideSummaryTitle && <h3 className={`text-2xl font-semibold ${textMain}`}>Top Priorities</h3>}
          <p className={`mt-1 text-xs ${textMuted}`}>
            {topPriorities.length > 0
              ? readOnly
                ? 'Fully-rated priorities across every department.'
                : 'Your fully-rated priorities across every department — use the arrows to rank them.'
              : 'Fill all three dots on a card below to make it a top priority and it\'ll show up here.'}
          </p>
        </div>
        {topPriorities.length > 0 && (
          // Columns wrap on narrow screens; each holds at most ROWS_PER_COLUMN.
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {priorityColumns.map((column, colIdx) => (
              <div key={colIdx} className="flex-1 min-w-[280px] space-y-2">
                {column.map((row, rowIdx) => {
                  const idx = colIdx * ROWS_PER_COLUMN + rowIdx;
                  return (
                    <div
                      key={row.key}
                      className={`flex items-center gap-2 rounded-lg border px-3 py-2 ${
                        darkMode ? 'bg-gray-800/50 border-gray-600' : 'bg-white border-gray-200'
                      }`}
                    >
                      <span className={`w-5 text-sm font-bold text-center shrink-0 ${textMuted}`}>{idx + 1}</span>
                      {row.emoji && <span className="text-lg leading-none shrink-0">{row.emoji}</span>}
                      <span className={`flex-1 text-sm font-medium truncate ${textMain}`} title={row.label}>
                        {row.label}
                      </span>
                      <span className={`shrink-0 px-2 py-0.5 rounded-full text-[11px] font-medium ${DEPT_PILL_COLORS[row.deptId] || 'bg-gray-500 text-white'}`}>
                        {row.deptName}
                      </span>
                      <Star className="w-4 h-4 shrink-0 fill-amber-500 text-amber-500" />
                      {!readOnly && (
                        <div className="shrink-0 flex flex-col">
                          <button
                            type="button"
                            onClick={() => moveTopPriority(idx, -1)}
                            disabled={idx === 0}
                            className={`p-0.5 rounded ${idx === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-gray-100 dark:hover:bg-gray-700'} ${textMuted}`}
                            title="Move up"
                          >
                            <ChevronUp className="w-3.5 h-3.5" />
                          </button>
                          <button
                            type="button"
                            onClick={() => moveTopPriority(idx, 1)}
                            disabled={idx === topPriorities.length - 1}
                            className={`p-0.5 rounded ${idx === topPriorities.length - 1 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-gray-100 dark:hover:bg-gray-700'} ${textMuted}`}
                            title="Move down"
                          >
                            <ChevronDown className="w-3.5 h-3.5" />
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Department sections: each with big centered header, rating, own Edit, editable cards when editing */}
      <div className="space-y-10">
          {DEPARTMENT_SECTIONS.map((sec, secIdx) => {
            const items = deptItems[sec.id] || [];
            const isLastSection = secIdx === DEPARTMENT_SECTIONS.length - 1;
            return (
              <div key={sec.id} className="space-y-3">
                {/* Department header — same style as portal materials sections */}
                <div className="flex items-center justify-center gap-3">
                  <span className={`h-px flex-1 max-w-[110px] ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
                  <span className="shrink-0 w-10 h-10 rounded-xl bg-red-50 dark:bg-red-900/30 flex items-center justify-center">
                    <span className="text-xl leading-none">{sec.emoji}</span>
                  </span>
                  <h3 className={`text-xl md:text-2xl font-bold tracking-tight leading-tight text-center ${textMain}`}>
                    {sec.name}
                  </h3>
                  <span className={`h-px flex-1 max-w-[110px] ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`} />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {items.map((item, i) => {
                    const card = typeof item === 'string' ? { emoji: '', label: item, highlighted: false, priority: 0 } : { ...item, highlighted: Boolean(item.highlighted), priority: typeof item.priority === 'number' ? item.priority : 0 };
                    const isGold = card.highlighted || card.priority >= 2;
                    const isCardEditing = !readOnly && editingCard && editingCard.deptId === sec.id && editingCard.index === i;
                    const cardBg = isGold
                      ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-300 dark:border-amber-600'
                      : (darkMode ? 'bg-gray-800/50 border-gray-600' : 'bg-gray-50 border-gray-200');
                    return (
                      <div key={i} className={`rounded-lg border p-3 min-h-[80px] flex flex-col items-center justify-between relative ${cardBg}`}>
                        {isCardEditing ? (
                          <>
                            <button
                              type="button"
                              onClick={finishEditCard}
                              className="absolute top-1 left-1 p-1 rounded text-green-600 hover:bg-green-100 dark:text-green-400 dark:hover:bg-green-900/30 focus:outline-none focus:ring-2 focus:ring-green-400"
                              title="Done"
                            >
                              <Check className="w-4 h-4" />
                            </button>
                            <button
                              type="button"
                              onClick={() => setEmojiPickerOpen({ deptId: sec.id, itemIndex: i })}
                              className="w-10 h-10 text-2xl border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 flex items-center justify-center mb-1 hover:ring-2 hover:ring-amber-400"
                              title="Pick emoji"
                            >
                              {card.emoji || '😊'}
                            </button>
                            <input
                              type="text"
                              value={card.label}
                              onChange={(e) => updateDeptItem(sec.id, i, 'label', e.target.value)}
                              onKeyDown={(e) => e.key === 'Enter' && finishEditCard()}
                              autoFocus
                              className={`w-full text-sm font-medium text-center bg-transparent border-b border-transparent hover:border-gray-400 focus:border-amber-400 focus:outline-none px-1 ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}
                              placeholder="Priority"
                            />
                            <div className="mt-2 flex items-center justify-center gap-1">
                              {[0, 1, 2].map((lvl) => {
                                const active = card.highlighted || card.priority >= lvl;
                                return (
                                  <button
                                    key={lvl}
                                    type="button"
                                    onClick={() => updateAndPersistItem(sec.id, i, 'priority', lvl)}
                                    className={`w-3 h-3 rounded-full border ${active ? 'bg-amber-400 border-amber-500' : 'bg-transparent border-gray-400 dark:border-gray-600'} ${lvl === 2 ? 'ml-1' : ''}`}
                                    title={lvl === 2 ? 'Highest priority' : lvl === 1 ? 'Medium priority' : 'Lowest priority'}
                                  />
                                );
                              })}
                            </div>
                            <button type="button" onClick={() => removeDeptItem(sec.id, i)} className="absolute top-1 right-1 p-1 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-red-600" title="Remove"><Trash2 className="w-3.5 h-3.5" /></button>
                          </>
                        ) : (
                          <>
                            {!readOnly && (
                              <button
                                type="button"
                                onClick={() => setEditingCard({ deptId: sec.id, index: i })}
                                className="absolute top-1 left-1 p-1 rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-500 dark:hover:text-gray-300 dark:hover:bg-gray-700 focus:outline-none"
                                title="Edit this priority"
                              >
                                <Edit2 className="w-3.5 h-3.5" />
                              </button>
                            )}
                            {card.emoji && <span className="text-2xl mb-1">{card.emoji}</span>}
                            <span className={`text-sm font-medium ${textMain}`}>{card.label || '—'}</span>
                            <div className="mt-2 flex items-center justify-center gap-1">
                              {[0, 1, 2].map((lvl) => {
                                const active = card.highlighted || card.priority >= lvl;
                                if (readOnly) {
                                  return (
                                    <span
                                      key={lvl}
                                      className={`w-3 h-3 rounded-full border ${active ? 'bg-amber-400 border-amber-500' : 'bg-transparent border-gray-400 dark:border-gray-600'} ${lvl === 2 ? 'ml-1' : ''}`}
                                    />
                                  );
                                }
                                return (
                                  <button
                                    key={lvl}
                                    type="button"
                                    onClick={() => updateAndPersistItem(sec.id, i, 'priority', lvl)}
                                    className={`w-3 h-3 rounded-full border ${active ? 'bg-amber-400 border-amber-500' : 'bg-transparent border-gray-400 dark:border-gray-600'} ${lvl === 2 ? 'ml-1' : ''}`}
                                    title={lvl === 2 ? 'Highest priority' : lvl === 1 ? 'Medium priority' : 'Lowest priority'}
                                  />
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                  {!readOnly && (
                    <button type="button" onClick={() => addDeptItem(sec.id)} className="rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 p-3 min-h-[60px] flex items-center justify-center gap-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 hover:border-amber-400">
                      <Plus className="w-5 h-5" /><span className="text-sm">Add Priority</span>
                    </button>
                  )}
                </div>
                {!readOnly && (
                  <p className={`text-xs text-center ${textMuted}`}>
                    Tip: tap the dots under a card — more filled dots = higher priority. Fill all three to turn it gold as a top priority.
                  </p>
                )}
                {isLastSection && (
                  <div className="flex justify-center pt-2">
                    <button
                      type="button"
                      onClick={() => topPrioritiesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700"
                    >
                      <ChevronUp className="w-4 h-4" /> Review Top Priorities
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Emoji picker modal for department cards */}
        {emojiPickerOpen && !readOnly && (
          <div
            className="fixed inset-0 bg-gray-900/75 flex items-center justify-center z-50"
            onClick={() => { setEmojiPickerOpen(null); setEmojiSearch(''); }}
          >
            <div
              className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-6 max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col mx-4`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-center mb-4 relative">
                <h3 className={`text-lg font-medium ${textMain}`}>Pick emoji</h3>
                <button
                  type="button"
                  onClick={() => { setEmojiPickerOpen(null); setEmojiSearch(''); }}
                  className={`absolute right-0 ${darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
              <input
                type="text"
                placeholder="Search emojis..."
                value={emojiSearch}
                onChange={(e) => setEmojiSearch(e.target.value)}
                className={`w-full px-3 py-2 border rounded-md mb-4 ${darkMode ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'}`}
              />
              <div className="overflow-y-auto flex-1 grid grid-cols-8 gap-2">
                {POPULAR_EMOJIS.filter((emoji) => !emojiSearch || emoji.includes(emojiSearch)).map((emoji, idx) => (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => {
                      updateAndPersistItem(emojiPickerOpen.deptId, emojiPickerOpen.itemIndex, 'emoji', emoji);
                      setEmojiPickerOpen(null);
                      setEmojiSearch('');
                    }}
                    className={`p-2 rounded-lg text-2xl hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-amber-400 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
              <div className="mt-4 flex justify-end">
                <button type="button" onClick={() => { setEmojiPickerOpen(null); setEmojiSearch(''); }} className={`px-4 py-2 rounded-md ${darkMode ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-200 hover:bg-gray-300'} ${textMain}`}>
                  Done
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}
